/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/5/2021
 */

import IntegrationStatus from "@shared/Billing/IntegrationStatus";
import DbBaseObject from "@shared/DbBaseObject";
import EmailIntegrationStatus from "@shared/Profile/EmailIntegrationStatus";
import {Type} from "@qwoach/class-transformer-wrapper"

export default class IntegrationsList extends DbBaseObject {

	zoomIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	gmailIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	outlookIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	stripeIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	paypalIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	cloverIntegration: IntegrationStatus = IntegrationStatus.NOT_SET
	@Type(() => EmailIntegrationStatus)
	emailIntegration: EmailIntegrationStatus = new EmailIntegrationStatus()

	setZoomIntegration(integrationStatus){
		this.zoomIntegration = integrationStatus
	}
	setStripeIntegration(integrationStatus){
		this.stripeIntegration = integrationStatus
	}
	setPayPalIntegration(integrationStatus){
		this.paypalIntegration = integrationStatus
	}
	setCloverIntegration(integrationStatus){
		this.cloverIntegration = integrationStatus
	}

	isZoomIntegrated(){
		return this.zoomIntegration === IntegrationStatus.INTEGRATED
	}

	isEmailIntegrated(){
		return this.emailIntegration.isIntegrated()
	}

	isEmailIntegrationPending(){
		return this.emailIntegration.isPending()
	}

	setEmailIntegrationPending(email,domain){
		return this.setEmailIntegration(IntegrationStatus.PENDING, email, domain)
	}
	setEmailIntegration(status, email,domain){
		return this.emailIntegration.setIntegration(status, email, domain)
	}

	isStripeIntegrated(){
		return this.stripeIntegration === IntegrationStatus.INTEGRATED
	}

	isPayPalIntegrated(){
		return this.paypalIntegration === IntegrationStatus.INTEGRATED
	}

	isCloverIntegrated(){
		return this.cloverIntegration === IntegrationStatus.INTEGRATED
	}

	hasPaymentIntegration(){
		return this.isStripeIntegrated() || this.isPayPalIntegrated() || this.isCloverIntegrated()
	}
	hasCreditCardIntegration(){
		return this.isStripeIntegrated() || this.isCloverIntegrated()
	}
}
